module.exports = __webpack_public_path__ + "static/img/android-btn.f903fb72.png";